import NOC from '@/class/common/const';
// import Auth from '@/auth';

const ENDPOINT = process.env.VUE_APP_ENDPOINT;

export interface ApiError {
  message: string;
  code: number;
  title: string;
}

export interface ApiResult<T> {
  result: string;
  data: T;
}

export default class {

  private endpoint = ENDPOINT;
  // private headers: Promise<Headers>;
  private headers = new Headers();
  private apiError = {} as ApiError;

  constructor() {
    // this.headers.append('authorization', 'auth');
    this.headers.append('Content-type', 'application/json');
    const token = localStorage.getItem(NOC.N16.DIR);
    if (token) {
      this.headers.append('authorization', token);
    }
    // console.log('constructor')
  }

  // Get
  public async get<Out>(adress: string, params?: object | undefined): Promise<ApiResult<Out>> {
    let url = `${this.endpoint}${adress}`;
    if (params) {
      const urlParams = new URLSearchParams();
      for (const key of Object.keys(params)) {
        urlParams.append(key, (params as any)[key]);
      }
      url = `${url}?${urlParams.toString()}`;
    }
    // console.log('api/common/index.tsの45行目：');
    // console.log('adress', adress);
    // console.log('authorization', this.headers.get('authorization'));
    return await this.fetcher<Out>(url, {
      method: 'GET',
      headers: this.headers,
    });
  }

  // Post
  public async post<In, Out>(adress: string, input: In): Promise<ApiResult<Out>> {
    const body = JSON.stringify(input);
    const headersObj = this.headers;
    // console.log('adress', adress);
    // console.log('authorization', this.headers.get('authorization'));
    headersObj.append('Content-Length', body.length.toString());
    return await this.fetcher<Out>(`${this.endpoint}${adress}`, {
      method: 'POST',
      headers: headersObj,
      body,
    });
  }

  // Post
  public async put<In, Out>(adress: string, input: In): Promise<ApiResult<Out>> {
    const body = JSON.stringify(input);
    const headersObj = this.headers;
    headersObj.append('Content-Length', body.length.toString());
    return await this.fetcher<Out>(`${this.endpoint}${adress}`, {
      method: 'PUT',
      headers: headersObj,
      body,
    });
  }

  // Delete
  public async delete<Out>(adress: string, params?: object | undefined): Promise<ApiResult<Out>> {
    let url = `${this.endpoint}${adress}`;
    if (params) {
      const urlParams = new URLSearchParams();
      for (const key of Object.keys(params)) {
        urlParams.append(key, (params as any)[key]);
      }
      url = `${url}?${urlParams}`;
    }
    return await this.fetcher<Out>(url, {
      method: 'DELETE',
      headers: await this.headers,
    });
  }

  // エラー確認
  public isError(): undefined | ApiError {
    return this.apiError;
  }

  private async fetcher<T = any>(input: RequestInfo, init?: RequestInit): Promise<ApiResult<T>> {
    return await wrap(fetch(input, init))
      // 処理毎に分けたかったらあとで分ける
      .then((res) => {
        return {result: NOC.API.RESULUT.SUCCESS, data: res};
      })
      .catch(async (error: Response) => {
        // console.log('erros');
        try {
          const body = await error.json();
          this.apiError = {
            message: body.message ? body.message : 'no message',
            title: body.title ? body.title : 'no title',
            code: error.status,
          };
        } catch (e) {
          // json変換不可はここで握りつぶす。
        }
        return {result: NOC.API.RESULUT.FAIL, data: null} as any;
    });
  }
}


const wrap = (task: Promise<Response>) => {
  return new Promise((resolve, reject) => {
    task
      .then((response) => {
        if (response.ok) {
          if (response.status === 200) {
            const contentType = response.headers.get('Content-Type');
            // console.log(contentType);
            if (contentType && (contentType === 'application/zip' || contentType === 'application/octet-stream' || contentType === 'text/csv; charset=utf-8' || contentType.indexOf('application/pdf') !== -1)) {
              response
                .blob()
                .then((res) => {
                  const disposition = response.headers.get('Content-disposition');
                  if (disposition && disposition.indexOf('attachment') >= 0) {
                    const anchor = document.createElement('a');
                    const FILENAME_KEY = 'filename=';
                    const filenameIdx = disposition.indexOf(FILENAME_KEY);
                    if (filenameIdx >= 0) {
                      anchor.download = disposition.slice(filenameIdx + FILENAME_KEY.length, disposition.length).replace(/"/g, '');
                    }
                    anchor.href = window.URL.createObjectURL(res);
                    anchor.click();
                    anchor.remove();
                  }
                  /* 日本語名の場合
                  else {
                    const url = URL.createObjectURL(res);
                    const anchor = document.createElement('a');
                    document.body.appendChild(anchor);
                    console.log(anchor)
                    anchor.download = 'RemoLabo_請求用資料.pdf';
                    anchor.href = url;
                    anchor.click();
                    anchor.remove();
                  }
                  */
                  resolve({ disposition, blob: res } as any);
                })
                .catch((error) => reject(error));
            } else {
              const token = response.headers.get('x-authorization');
              // console.log('disposition', token);
              if (token) {
                localStorage.setItem(NOC.N16.DIR, token);
              }
              response
                .json()
                .then((res) => (resolve(res)))
                .catch((error) => reject(error));
            }
          } else {
            reject(response);
          }
        } else {
          reject(response);
        }
      })
      .catch((error) => reject(error));
  });
};

